import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import {computed, inject, onMounted} from 'vue';
    import {useStore} from 'vuex';
    import {useTranslation, useGlobalProperties} from '@malt/vue3-use';
    import {useRouter} from 'vue-router';
    import {DI} from '@/profile-creation-wizard/common/DependencyInjection';
    import mutations from '@/profile-creation-wizard/store/creation/mutations';
    import FunnelHeader from './components/Header.vue';
    import Shapes from './common/ui/Shapes.vue';
    import Loader from './common/ui/Loader.vue';
    import getters from './store/completion/getters';
    import {pushNotification} from '@malt/joy-entrypoint/src/js/notification';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

    const router = useRouter();
    const store = useStore();
    const {msg, $requireMsg} = useTranslation();
    const context = useGlobalProperties();

    const mobileAppLinksRepository = inject(DI.mobileAppLinksRepository)!;

    const isMaltStrategy = computed(() => store.state.isFunnelStrategy);
    const isLoadingData = computed(() => store.getters[getters.isLoading]);
    const hasSignupFunnelV2Enabled = computed(
        () => context.$features.freelancerConvergenceSignup === true || context.$features.freelancerRegularNewSignup === true,
    );

    onMounted(async () => {
        $requireMsg('profile.creation.*');
        const [links] = await mobileAppLinksRepository.getLinks();

        if (links) {
            store.commit(mutations.setupQrcode, `${links.qrcodeUrl}&w=113&orig=signup`);
        }
        if (router.currentRoute.value.query.email) {
            router.push({name: router.currentRoute.value.name});
            pushNotification(msg('index.email.validation.ok'));
        }
    });

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    (hasSignupFunnelV2Enabled.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(Shapes, { "is-malt-strategy": isMaltStrategy.value }, null, 8, ["is-malt-strategy"]),
          _createVNode(FunnelHeader),
          (isLoadingData.value)
            ? (_openBlock(), _createBlock(Loader, { key: 0 }))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}
}

})